module.exports = __webpack_public_path__ + "static/assets/aed751f4a9c15923844e4daad240e7e1.png";